'use strict';

var { getTranslation } = require('../common/jsTranslations');

module.exports = function () {
    var $wrapper = $('<div class="position-fixed right-6 bottom-6 z-1026 fade pe-none"></div>');
    var $btn = $(`
        <button type="button" class="btn btn-primary d-flex align-items-center gap-1 px-1-5 px-md-3">
            <span class="d-none d-md-block">${getTranslation('label.gototop')}</span>
            <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 0 24 24" width="22" class="w-auto h-auto"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>
        </button>
    `);
    $wrapper.append($btn);
    $('body').append($wrapper);

    var threshold = window.innerHeight;

    $(window).on('scroll.scrollToTop', function () {
        if ($(this).scrollTop() >= threshold) {
            $wrapper.addClass('show').removeClass('pe-none');
        } else {
            $wrapper.removeClass('show').addClass('pe-none');
        }
    });

    $btn.on('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
};
